import jsonServerRestClient from './jsonServer';
export { jsonServerRestClient };
export * from './types';



// WEBPACK FOOTER //
// src/rest/index.js